import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { getDppYN, updateDppYn } from "../../helpers/backend_helper";
import { getDppYnSuccess, updateDppYnSuccess } from "./actions";
import { GET_DPP_YN, UPDATE_DPP_YN } from "./actionTypes";

function* onGetDppYn({ payload : data }) {
  try {
    const response = yield call(getDppYN);
    yield put(getDppYnSuccess(response));
    
  } catch (error) {
    console.log('GetDppYn error >> ' + error);
  }
}

function* onUpdateDppYn({ payload : data }) {
  try {
    const response = yield call(updateDppYn, data);
    yield put(updateDppYnSuccess(response));
    
  } catch (error) {
    console.log('updateDppYn error >> ' + error);
  }
}

function* AdmEmailManagementSaga() {
  yield takeLatest(GET_DPP_YN, onGetDppYn);
  yield takeLatest(UPDATE_DPP_YN, onUpdateDppYn);
}

export default AdmEmailManagementSaga

